export default __webpack_public_path__ + "static/media/ic_tri_arrow_black.a824f582.svg";